import Constants from "../utils/consts";

var http = require("follow-redirects").https;
var fs = require("fs");
var qs = require("querystring");

export default async function updateCambioCorsoStudente(
  uname,
  token,
  id_studente,
  corso_precedente,
  corso_nuovo,
  mantieni_assenze = true
) {
  return new Promise(function(resolve, reject) {
    var options = {
      method: "POST",
      hostname: Constants.ipAddress,
      path: Constants.apisFolder + "updateCambioCorsoStudente.php",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Cookie: "uid=e02675a1a7516909792f6850dffcd5fe",
      },
      maxRedirects: 20,
    };

    var req = http.request(options, function(res) {
      var chunks = [];

      res.on("data", function(chunk) {
        chunks.push(chunk);
      });

      res.on("end", function(chunk) {
        var body = Buffer.concat(chunks);
        var bodyString = body.toString();

        console.log(
          "✅ updateCambioCorsoStudente - Response status:",
          res.statusCode
        );
        console.log(
          "✅ updateCambioCorsoStudente - Response body:",
          bodyString
        );

        try {
          var response = JSON.parse(bodyString);
          if (response.result === "ok") {
            console.log("✅ Cambio corso completato con successo!");
            resolve(response);
          } else {
            console.error("❌ Errore dal backend:", response);
            reject(new Error(response.error || "Errore sconosciuto"));
          }
        } catch (e) {
          console.error("❌ Risposta non JSON:", bodyString);
          reject(new Error("Risposta invalida dal server"));
        }
      });

      res.on("error", function(error) {
        console.error("❌ Errore HTTP:", error);
        reject(error);
      });
    });

    var postData = qs.stringify({
      token: token,
      uname: uname,
      id_studente: id_studente,
      corso_precedente: corso_precedente,
      corso_nuovo: corso_nuovo,
      mantieni_assenze: mantieni_assenze ? "1" : "0",
    });

    console.log("updateCambioCorsoStudente - Sending to backend:", {
      id_studente,
      corso_precedente,
      corso_nuovo,
      mantieni_assenze,
      mantieni_assenze_string: mantieni_assenze ? "1" : "0",
    });

    req.write(postData);

    req.end();
  });
}
